/* Presentation only. The original form nodes, preview layers and handlers are retained. */
(() => {
  function enhance(root) {
    if (root.dataset.slateReady) return;
    const form = root.querySelector('form[id^="AddToCartForm"]');
    const preview = form?.querySelector('.product-image-preview-wrapper,.mockup-preview');
    const destination = root.querySelector('[data-slate-preview]');
    if (!form || !preview || !destination) return;
    const warning = preview.previousElementSibling;
    if (warning?.matches('label.form__label')) destination.append(warning);
    destination.append(preview);
    const document = root.ownerDocument;
    let number = 0;
    form.querySelectorAll(':scope > .product-form__input').forEach(group => {
      const label = group.querySelector(':scope > .form__label');
      if (!label || !group.querySelector('input:not([type="hidden"]),select')) return;
      if (group.querySelector('#custom-message')) {
        const details = document.createElement('details');
        details.className = 'slate-notes';
        const summary = document.createElement('summary');
        summary.textContent = label.textContent.trim();
        group.before(details);
        details.append(summary, group);
        return;
      }
      const step = document.createElement('span');
      step.className = 'step';
      step.setAttribute('aria-hidden', 'true');
      step.textContent = String(++number);
      label.prepend(step);
      label.classList.add('slate-step-label');
    });
    const submit = form.querySelector('button[type="submit"]');
    const assurance = form.querySelector('.atelier-order-assurance');
    if (submit && assurance) submit.after(assurance);
    const review = form.querySelector('[data-atelier-review]');
    if (review) review.open = true;
    root.dataset.slateReady = 'true';
    // The native flat preview sizes the name relative to its current image height.
    root.ownerDocument.defaultView?.dispatchEvent(new Event('resize'));
  }
  const init = () => document.querySelectorAll('[data-slate-product]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
